<template>
  <v-card fill-height rounded class="card-vertical-main">
    <!-- <v-card-title class="font-weight-bold card_title--text text-lg-h6 text-sm-h5 body-1 pa-0" > -->
    <v-card-title class="font-weight-bold card_title--text text-lg-h6 text-sm-h5 body-1 pl-2 pr-0 py-0" style="font-family: Roboto, sans-serif">
      {{ $t(headerTitle) }}

      <i-search-panel v-if="showSearchPanel" :searchPanel="searchPanel"></i-search-panel>
      <div v-if="IsUseAddition" class="additionCss"><slot name="addition"> </slot></div>
      <v-spacer />
      <slot name="switch">
        
      </slot>
      <i-button-list :key="btnKey" :useBtnList="useBtnList" :unUseBtnList="unUseBtnList" :customBtnList="customBtnList" :refresh="refresh" @btnRefreshClick="clickRefresh" @btnClick="clickButton" />
    </v-card-title>
    <!-- <v-divider class="mx-2" v-if="divider"></v-divider> -->
    <v-card-text class="pa-0 pt-1" style="font-family: Roboto, sans-serif">
      <!-- <i-system-bar></i-system-bar> -->
      <slot name="body">
        <!-- {{}} -->
      </slot>
    </v-card-text>
  </v-card>
</template>

<script>
import iButtonList from './iButtonList.vue'
import iSearchPanel from '@/components/common/iSearchPanel.vue'
import iSystemBar from '@/components/common/iSystemBar.vue'

export default {
  name: 'i-card-vertical',
  components: {
    // 'i-system-bar': iSystemBar,
    iButtonList,
    iSearchPanel
  },
  props: {
    headerTitle: {
      type: String,
      default: '제목'
    },
    color: {
      type: String,
      default: 'card_bg'
    },
    divider: {
      type: Boolean,
      default: false
    },
    // 버튼 리스트
    useBtnList: {
      type: Array,
      default: () => ['']
    },
    unUseBtnList: {
      type: Array,
      default: () => ['']
    },
    customBtnList: {
      type: Array,
      default: () => []
    },
    btnKey: {
      type: Number,
      default: 0
    },
    refresh: {
      type: Boolean,
      default: false
    },
    IsUseAddition: {
      type: Boolean,
      default: false
    },
    showSearchPanel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchPanel: false
    }
  },
  mounted() {
    this.foundGridComponent()
  },
  methods: {
    // 버튼 클릭 시 각 id별로 이벤트생성
    clickButton(targetButton) {
      this.$emit(targetButton.id)
    },
    clickRefresh() {
      this.$emit('btnRefreshClick')
    },
    foundGridComponent() {
      
      // 그리드 찾기
      let childrenCompoent = this.$children[0].$children
      let gridComponent = childrenCompoent.find(element => {
        return element.instance ? element.instance.NAME === 'dxDataGrid' : false
      })
      this.searchPanel = !!gridComponent
    }
  }
}
</script>

<style lang="scss" scoped>
.additionCss {
  font-size: medium;
  font-weight: 600;
  margin-left: 5px;
  color: #222;
}
</style>
